"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTag = void 0;
var OrderTag;
(function (OrderTag) {
    OrderTag["AIRSHOP_ORDER"] = "AIRSHOP_ORDER";
    OrderTag["AMAZON_SFP"] = "AMAZON_SFP";
    OrderTag["BRANDED_ORDER"] = "BRANDED_ORDER";
    OrderTag["BULK_ORDER"] = "BULK_ORDER";
    OrderTag["DELIVERED_DUTY_PAID"] = "DELIVERED_DUTY_PAID";
    OrderTag["DISTRIBUTION_ORDER"] = "DISTRIBUTION_ORDER";
    OrderTag["EBAY_ESTIMATED_FAST_TAG"] = "EBAY_ESTIMATED_FAST_TAG";
    OrderTag["EBAY_FAST_TAG"] = "EBAY_FAST_TAG";
    OrderTag["FEFO_ORDER"] = "FEFO_ORDER";
    OrderTag["GOOGLE_FAST_TAG"] = "GOOGLE_FAST_TAG";
    OrderTag["INTERNATIONAL_ORDER"] = "INTERNATIONAL_ORDER";
    OrderTag["INVENTORY_DISPOSAL"] = "INVENTORY_DISPOSAL";
    OrderTag["INVENTORY_REMOVAL"] = "INVENTORY_REMOVAL";
    OrderTag["INVENTORY_TRACKING"] = "INVENTORY_TRACKING";
    OrderTag["INVENTORY_TRANSFER"] = "INVENTORY_TRANSFER";
    OrderTag["LOT_DISPOSAL"] = "LOT_DISPOSAL";
    OrderTag["LOT_REMOVAL"] = "LOT_REMOVAL";
    OrderTag["PARTIALLY_FULFILLED"] = "PARTIALLY_FULFILLED";
    OrderTag["REPLACE_LOST_ORDER"] = "REPLACE_LOST_ORDER";
    OrderTag["SHOPIFY_FAST_TAG"] = "SHOPIFY_FAST_TAG";
    OrderTag["SHOPIFY_PROMISE"] = "SHOPIFY_PROMISE";
    OrderTag["STRESS_TEST"] = "STRESS_TEST";
    OrderTag["SUBSCRIPTION_ORDER"] = "SUBSCRIPTION_ORDER";
    OrderTag["TEST_ORDER"] = "TEST_ORDER";
    OrderTag["TRIBAL_NUTRITION_REPLACEMENT"] = "TRIBAL_NUTRITION_REPLACEMENT";
    OrderTag["WALMART_FAST_TAG"] = "WALMART_FAST_TAG";
    OrderTag["WEBSITE_FAST_TAG"] = "WEBSITE_FAST_TAG";
    OrderTag["WISH_EXPRESS_FAST_TAG"] = "WISH_EXPRESS_FAST_TAG";
})(OrderTag = exports.OrderTag || (exports.OrderTag = {}));
//# sourceMappingURL=OrderTag.js.map